  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_RegisterIdBoxService = {
  wu_idBoxAvailability,
  wu_registerRequest,
  wu_invalidateRequest,
  wu_getStatus,
};
//----------------------------------------------------------------------------------------------------
function wu_idBoxAvailability(reqData) {
  const methName = "wu_idBoxAvailability ";

  //NSUserDefaults *dftmpApplication = [NSUserDefaults standardUserDefaults];
  //NSString *aIndexApplicationStr = [dftmpApplication stringForKey:UD_UserSelectedCountry]!= nil ? [dftmpApplication stringForKey:UD_UserSelectedCountry] : @"GR";
  //aIndexApplicationStr = (mainDelegate.NavBarMode == NavBarMode_PL) ? @"GR" : aIndexApplicationStr;
  //if(mainDelegate.print_logs){NSLog(@"aIndexApplicationStr=%@",aIndexApplicationStr);}

  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/idBoxAvailability";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_registerRequest(reqData) {
  const methName = "wu_registerRequest ";

  //NSUserDefaults *dftmpApplication = [NSUserDefaults standardUserDefaults];
  //NSString *aIndexApplicationStr = [dftmpApplication stringForKey:UD_UserSelectedCountry]!= nil ? [dftmpApplication stringForKey:UD_UserSelectedCountry] : @"GR";
  //aIndexApplicationStr = (mainDelegate.NavBarMode == NavBarMode_PL) ? @"GR" : aIndexApplicationStr;
  //if(mainDelegate.print_logs){NSLog(@"aIndexApplicationStr=%@",aIndexApplicationStr);}

  let cid       = reqData.cid.replace(/@/g,"%40");
  let idBoxFlow = reqData.idBoxFlow;

  let localUrl   = api.url + "/wbrestservices-1.0.0/idBox/registerRequest?cid="+cid+"&idBoxFlow="+idBoxFlow;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_invalidateRequest(reqData) {
  const methName = "wu_invalidateRequest ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/idBox/invalidateRequest?requestId="+reqData.requestId;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_getStatus(reqData) {
  const methName = "wu_getStatus ";

  let cid       = reqData.cid.replace(/@/g,"%40");
  let idBoxFlow = reqData.idBoxFlow;

  let localUrl   = api.url + "/wbrestservices-1.0.0/idBox/getStatus?cid="+cid+"&idBoxFlow="+idBoxFlow;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
